var React = require('react');

function inlineSvg (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.0553 6.38278L0 12.7656L5.58001e-07 0L11.0553 6.38278Z","fill":"#FCFEFF"}));
}

inlineSvg.defaultProps = {"width":"12","height":"13","viewBox":"0 0 12 13","fill":"none","className":"inline-svg"};

module.exports = inlineSvg;

inlineSvg.default = inlineSvg;
